<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-6">
                <h3 class="page-header" style="margin-bottom: 0px;">
                    <i class="fa fa-calendar animated bounceInDown show-info"></i>
                    <span> Payment Settings</span>
                </h3>
            </div>
        </div>

        <div class="backdate-section">
            <h4>Back-dated EMI / down payments</h4>
            <p class="text-muted">
                While locked, EMI payments and EMI-sale down payments cannot be dated before
                the lock date chosen below. When unlocked, any date can be used until an admin locks it again.
            </p>

            <div v-if="loading">Loading…</div>
            <template v-else>
                <div v-if="unlocked" class="backdate-status backdate-open">
                    <i class="fa fa-unlock"></i> Unlocked: any date is allowed
                    <span v-if="changedby"> (unlocked by {{ changedby }}<span v-if="changedat"> on {{ changedat }}</span>)</span>
                </div>
                <div v-else class="backdate-status backdate-closed">
                    <i class="fa fa-lock"></i> Locked: dates before {{ lockdateLabel }} are not allowed
                    <span v-if="changedby"> (locked by {{ changedby }}<span v-if="changedat"> on {{ changedat }}</span>)</span>
                </div>

                <div v-if="isAdmin" class="backdate-actions">
                    <label for="backdate-lockdate">Lock dates before</label>
                    <input id="backdate-lockdate" v-model="lockdate" type="date" class="form-control backdate-date"
                        :max="today">
                    <button v-if="unlocked" class="btn btn-danger" :disabled="saving" @click="lock()">
                        <i class="fa fa-lock"></i> Lock
                    </button>
                    <template v-else>
                        <button class="btn btn-danger" :disabled="saving || lockdate == savedLockdate" @click="lock()">
                            <i class="fa fa-calendar"></i> Change lock date
                        </button>
                        <button class="btn btn-primary" :disabled="saving" @click="unlock()">
                            <i class="fa fa-unlock"></i> Unlock
                        </button>
                    </template>
                </div>
                <p v-else class="text-muted" style="margin-top: 12px;">Only an admin can lock or unlock back-dated payments.</p>
            </template>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: true,
            saving: false,
            unlocked: false,
            changedby: null,
            changedat: null,
            lockdate: '',
            savedLockdate: '',
            today: moment().format('YYYY-MM-DD'),
        }
    },
    computed: {
        ...mapGetters(['loggedinuser']),
        isAdmin() {
            return (this.loggedinuser?.role ?? 0) >= 2
        },
        lockdateLabel() {
            return this.savedLockdate ? moment(this.savedLockdate, 'YYYY-MM-DD').format('DD-MM-YYYY') : 'the 1st of this month'
        },
    },
    mounted() {
        this.call('status')
    },
    methods: {
        unlock() {
            this.call('enable')
        },
        lock() {
            if (!this.lockdate) {
                this.$notify({ text: 'Choose the lock date', type: 'error' })
                return
            }
            if (this.lockdate > this.today) {
                this.$notify({ text: 'The lock date cannot be after today', type: 'error' })
                return
            }
            this.call('disable', { lockdate: this.lockdate })
        },
        call(action, params) {
            this.saving = action != 'status'
            window.axios.post('api/vsdigi/settings/backdate/' + action, params || {})
                .then(response => {
                    const data = response.data || {}
                    this.unlocked = !!data.unlocked
                    this.changedby = data.changedby
                    this.changedat = data.changedat ? moment.unix(data.changedat).format('DD-MM-YYYY hh:mm A') : null
                    this.savedLockdate = data.lockdate || ''
                    this.lockdate = this.savedLockdate
                    if (action == 'enable') this.$notify({ text: 'Back-dated payments unlocked', type: 'success' })
                    if (action == 'disable') this.$notify({ text: 'Back-dated payments locked before ' + this.lockdateLabel, type: 'success' })
                })
                .catch(error => {
                    console.log(error)
                    const errors = error?.response?.data?.errors
                    this.$notify({ text: (errors && Object.values(errors)[0]?.[0]) || error?.response?.data?.message || 'Could not update the setting', type: 'error' })
                })
                .finally(() => {
                    this.loading = false
                    this.saving = false
                })
        },
    },
}
</script>
<style scoped>
.backdate-section {
    background: #fff;
    padding: 16px;
    margin-top: 16px;
    border-radius: 4px;
}
.backdate-status {
    display: inline-block;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 14px;
}
.backdate-open {
    background: #fff3cd;
    color: #856404;
}
.backdate-closed {
    background: #e9ecef;
    color: #495057;
}
.backdate-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
}
.backdate-actions label {
    margin: 0;
}
.backdate-date {
    width: auto;
}
</style>
